<template>
    <section class="container">
        <Alerts />

        <div class="mt-130">
            <div class="container">
                <span> تعداد تصاویر : {{ images.length }} </span>
            </div>

            <hr />

            <div class="container py-3">

                <div class="input-group custom-file-button">
                    <label class="input-group-text" for="inputGroupFile">انتخاب فایل</label>
                    <input class="form-control" type="file" id="inputGroupFile" ref="file"
                        v-on:change="handleFileUpload()" />

                    <button class="btn btn-success" @click="upload">
                        <i class="bi bi-save"></i>
                        آپلود
                    </button>
                    <span v-show="loading" class="loader">
                        <img src="\src\assets\img\4colors.gif" alt="" style="width: 50px;">
                    </span>
                </div>





            </div>

            <hr />

            <div style="display: block; margin: 0 auto; text-align: center" class="container">
                <div class="card-item" v-for="item in images" :key="item.fileName">
                    <img v-lazy="item.fileName" class="image-item" alt="" />
                    <button @click="deleteFile(item.fileName)" class="deleteBtn">حذف</button>

                </div>
                <div class="card-item-clear"></div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapGetters } from "vuex";
    import Alerts from "@/components/Alerts";
    import Swal from "sweetalert2";
    import axios from "axios";

    export default {
        components: {
            Alerts,
        },
        computed: {
            ...mapGetters({
                currentUser: "currentUser",
                images: "controlPanelX/imagesResult",
            }),
        },
        data() {
            return {
                loading: false,
                currentRowSelected: {},
                contentCategorySelected: null,
                user: null,
            };
        },
        watch: {
            currentUser() {
                if (this.currentUser != undefined) {
                    this.loadData();
                }
            },
        },
        methods: {
            async deleteFile(fileName) {
                await axios
                    .post("/api/file/delete", fileName)
                    .then((res) => {
                        this.$store.state.successAlert = true;
                        this.$store.state.successMessage = res.data.value;
                        this.$store.dispatch("controlPanelX/getImages");
                    })
                    .catch((error) => {
                        this.$store.state.dangerAlert = true;
                        this.$store.state.dangerMessage = 'بروز خطا در حذف عکس';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
            },
            async upload() {
                this.loading = true;
                let formData = new FormData();
                formData.append("file", this.file);
                await axios
                    .post("/api/file/upload", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        this.$store.state.successAlert = true;
                        this.$store.state.successMessage = res.data.value;
                        this.$store.dispatch("controlPanelX/getImages");
                        this.$refs.file.value = null;
                    })
                    .catch((error) => {
                        this.$store.state.dangerAlert = true;
                        this.$store.state.dangerMessage = 'بروز خطا در آپلود عکس';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            loadData() {
                this.user = this.$store.state.currentUser;
            },
        },
        created() {
            this.$store.dispatch("controlPanelX/getImages");
        },
        mounted() { },
    };
</script>


<style scoped>
    .input-group {
        width: 50% !important;
    }

    .deleteBtn {
        position: relative;
        left: 96px;
        top: -26px;
        border-radius: 25px;
        border: 1px solid #bbbbbb;
        height: 25px;
    }

    .custom-file-button input[type=file] {
        margin-left: -2px !important;
    }

    .custom-file-button input[type=file]::-webkit-file-upload-button {
        display: none;
    }

    .custom-file-button input[type=file]::file-selector-button {
        display: none;
    }

    .custom-file-button:hover label {
        background-color: #dde0e3;
        cursor: pointer;
    }

    .mt-130 {
        margin-top: 130px;
    }

    .image-item {
        width: 100%;
        height: 100%;
    }

    .card-item {
        border: 1px solid #e3e3e3;
        height: 140px;
        width: 240px;
        float: right;
        margin: 5px;
    }

    .card-item img {
        box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.18);
        -webkit-box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.18);
        -moz-box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.18);
    }

    .card-item-clear {
        clear: both;
    }

    @media only screen and (max-width: 600px) {
        .card-item {
            float: right;
            width: 100%;
        }
    }
</style>